import { clsx } from 'clsx';

type IconProps = {
  icon: string;
  className?: string;
};

export function Icon({ icon, className }: IconProps) {
  return (
    <i
      className={clsx('fa-solid', `fa-${icon}`, 'fa-icon shrink-0', className)}
      aria-hidden
    />
  );
}

type ExpandToggleIconProps = {
  expanded: boolean;
  className?: string;
};

export function ExpandToggleIcon({ expanded, className }: ExpandToggleIconProps) {
  return (
    <Icon
      icon="chevron-down"
      className={clsx(
        'text-unilink-text-primary transition-transform',
        expanded && 'rotate-180',
        className
      )}
    />
  );
}
